<template>
  <div class="feedback-page">
    <div class="feedback-container">
      <div class="feedback-header">
        <div class="header-content">
          <h1 class="page-title">
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" viewBox="0 0 20 20">
              <path d="M9.56 2a2.5 2.5 0 0 1 2.452 2.99L11.609 7h2.235a2.75 2.75 0 0 1 2.713 3.202l-.681 4.082A3.25 3.25 0 0 1 12.67 17H4.5A1.5 1.5 0 0 1 3 15.5V9.238a1.5 1.5 0 0 1 1.059-1.433l1.14-.35.139-.048a2.75 2.75 0 0 0 1.56-1.453L8.41 2.59l.07-.13A1 1 0 0 1 9.322 2zM7.81 6.365a3.75 3.75 0 0 1-2.126 1.98l-.192.065-1.14.35A.5.5 0 0 0 4 9.239V15.5a.5.5 0 0 0 .5.5h8.17a2.25 2.25 0 0 0 2.22-1.88l.68-4.082A1.75 1.75 0 0 0 13.844 8H11a.5.5 0 0 1-.49-.598l.521-2.608A1.5 1.5 0 0 0 9.561 3h-.238z"/>
            </svg>
            Monitoring des feedbacks
          </h1>
          <p class="page-subtitle">Analyse des retours utilisateurs sur les dossiers</p>
        </div>
        <router-link :to="{ name: 'adminDashboard' }" class="back-button">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"/>
          </svg>
          Retour au dashboard
        </router-link>
      </div>

      <!-- Loading State -->
      <div v-if="loading" class="loading-state-full">
        <div class="loading-spinner"></div>
        <p>Chargement des feedbacks...</p>
      </div>

      <!-- Error State -->
      <div v-else-if="error" class="error-state">
        <p>{{ error }}</p>
        <button @click="fetchFeedbackData" class="retry-button">Réessayer</button>
      </div>

      <!-- Content -->
      <template v-else-if="feedbackData">
        <!-- Stats Cards -->
        <div class="stats-row">
          <div class="stat-card stat-card-blue">
            <div class="stat-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                <path d="M4.285 9.567a.5.5 0 0 1 .683.183A3.5 3.5 0 0 0 8 11.5a3.5 3.5 0 0 0 3.032-1.75.5.5 0 1 1 .866.5A4.5 4.5 0 0 1 8 12.5a4.5 4.5 0 0 1-3.898-2.25.5.5 0 0 1 .183-.683M7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5m4 0c0 .828-.448 1.5-1 1.5s-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5"/>
              </svg>
            </div>
            <div class="stat-info">
              <div class="stat-value">{{ feedbackData.stats.total }}</div>
              <div class="stat-label">Total feedbacks</div>
            </div>
          </div>

          <div class="stat-card stat-card-green">
            <div class="stat-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 20 20">
                <path d="M9.56 2a2.5 2.5 0 0 1 2.452 2.99L11.609 7h2.235a2.75 2.75 0 0 1 2.713 3.202l-.681 4.082A3.25 3.25 0 0 1 12.67 17H4.5A1.5 1.5 0 0 1 3 15.5V9.238a1.5 1.5 0 0 1 1.059-1.433l1.14-.35.139-.048a2.75 2.75 0 0 0 1.56-1.453L8.41 2.59l.07-.13A1 1 0 0 1 9.322 2zM7.81 6.365a3.75 3.75 0 0 1-2.126 1.98l-.192.065-1.14.35A.5.5 0 0 0 4 9.239V15.5a.5.5 0 0 0 .5.5h8.17a2.25 2.25 0 0 0 2.22-1.88l.68-4.082A1.75 1.75 0 0 0 13.844 8H11a.5.5 0 0 1-.49-.598l.521-2.608A1.5 1.5 0 0 0 9.561 3h-.238z"/>
              </svg>
            </div>
            <div class="stat-info">
              <div class="stat-value">
                {{ feedbackData.stats.positive }}
                <span class="stat-percentage">({{ positivePercent }}%)</span>
              </div>
              <div class="stat-label">Positifs</div>
            </div>
          </div>

          <div class="stat-card stat-card-red">
            <div class="stat-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 20 20">
                <path d="M12.67 3a3.25 3.25 0 0 1 3.206 2.716l.68 4.082A2.75 2.75 0 0 1 13.845 13H11.61l.403 2.01A2.5 2.5 0 0 1 9.56 18h-.238a1 1 0 0 1-.843-.46l-.069-.13-1.514-3.364a2.75 2.75 0 0 0-1.56-1.453l-.139-.047-1.14-.35A1.5 1.5 0 0 1 3 10.761V4.5A1.5 1.5 0 0 1 4.5 3zM4.5 4a.5.5 0 0 0-.5.5v6.262a.5.5 0 0 0 .353.477l1.14.35.19.065a3.75 3.75 0 0 1 2.127 1.98L9.323 17h.238a1.5 1.5 0 0 0 1.47-1.794l-.521-2.608A.5.5 0 0 1 11 12h2.844a1.75 1.75 0 0 0 1.726-2.038l-.68-4.082A2.25 2.25 0 0 0 12.67 4z"/>
              </svg>
            </div>
            <div class="stat-info">
              <div class="stat-value">
                {{ feedbackData.stats.negative }}
                <span class="stat-percentage">({{ negativePercent }}%)</span>
              </div>
              <div class="stat-label">Negatifs</div>
            </div>
          </div>

          <div class="stat-card stat-card-orange">
            <div class="stat-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
                <path d="M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4.414A2 2 0 0 0 3 11.586l-2 2V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12.793a.5.5 0 0 0 .854.353l2.853-2.853A1 1 0 0 1 4.414 12H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"/>
                <path d="M3 3.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5M3 6a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9A.5.5 0 0 1 3 6m0 2.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5"/>
              </svg>
            </div>
            <div class="stat-info">
              <div class="stat-value">{{ commentRate }}%</div>
              <div class="stat-label">Taux de commentaires</div>
            </div>
          </div>
        </div>

        <!-- Breakdown by mode -->
        <div class="mode-breakdown-section">
          <h2 class="section-title">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
              <path d="M1 2.5A1.5 1.5 0 0 1 2.5 1h3A1.5 1.5 0 0 1 7 2.5v3A1.5 1.5 0 0 1 5.5 7h-3A1.5 1.5 0 0 1 1 5.5zM2.5 2a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5zm6.5.5A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v3A1.5 1.5 0 0 1 13.5 7h-3A1.5 1.5 0 0 1 9 5.5zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5zM1 10.5A1.5 1.5 0 0 1 2.5 9h3A1.5 1.5 0 0 1 7 10.5v3A1.5 1.5 0 0 1 5.5 15h-3A1.5 1.5 0 0 1 1 13.5zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5zm6.5.5A1.5 1.5 0 0 1 10.5 9h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 13.5zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5z"/>
            </svg>
            Repartition par mode
          </h2>
          <div class="mode-cards">
            <div
              v-for="(data, mode) in feedbackData.by_mode"
              :key="mode"
              class="mode-card"
            >
              <div class="mode-card-header">
                <span class="mode-badge" :style="{ background: modeColor(mode) }">{{ mode }}</span>
              </div>
              <div class="mode-stats">
                <div class="mode-stat positive">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M9.56 2a2.5 2.5 0 0 1 2.452 2.99L11.609 7h2.235a2.75 2.75 0 0 1 2.713 3.202l-.681 4.082A3.25 3.25 0 0 1 12.67 17H4.5A1.5 1.5 0 0 1 3 15.5V9.238a1.5 1.5 0 0 1 1.059-1.433l1.14-.35.139-.048a2.75 2.75 0 0 0 1.56-1.453L8.41 2.59l.07-.13A1 1 0 0 1 9.322 2zM7.81 6.365a3.75 3.75 0 0 1-2.126 1.98l-.192.065-1.14.35A.5.5 0 0 0 4 9.239V15.5a.5.5 0 0 0 .5.5h8.17a2.25 2.25 0 0 0 2.22-1.88l.68-4.082A1.75 1.75 0 0 0 13.844 8H11a.5.5 0 0 1-.49-.598l.521-2.608A1.5 1.5 0 0 0 9.561 3h-.238z"/>
                  </svg>
                  <span>{{ data.positive }}</span>
                </div>
                <div class="mode-stat negative">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M12.67 3a3.25 3.25 0 0 1 3.206 2.716l.68 4.082A2.75 2.75 0 0 1 13.845 13H11.61l.403 2.01A2.5 2.5 0 0 1 9.56 18h-.238a1 1 0 0 1-.843-.46l-.069-.13-1.514-3.364a2.75 2.75 0 0 0-1.56-1.453l-.139-.047-1.14-.35A1.5 1.5 0 0 1 3 10.761V4.5A1.5 1.5 0 0 1 4.5 3zM4.5 4a.5.5 0 0 0-.5.5v6.262a.5.5 0 0 0 .353.477l1.14.35.19.065a3.75 3.75 0 0 1 2.127 1.98L9.323 17h.238a1.5 1.5 0 0 0 1.47-1.794l-.521-2.608A.5.5 0 0 1 11 12h2.844a1.75 1.75 0 0 0 1.726-2.038l-.68-4.082A2.25 2.25 0 0 0 12.67 4z"/>
                  </svg>
                  <span>{{ data.negative }}</span>
                </div>
                <div class="mode-stat total">
                  <span class="mode-total">{{ data.positive + data.negative }} total</span>
                </div>
              </div>
              <div class="mode-bar">
                <div
                  class="mode-bar-positive"
                  :style="{ width: modePositivePercent(data) + '%' }"
                ></div>
              </div>
            </div>
          </div>
        </div>

        <!-- Feedbacks Table -->
        <div class="feedbacks-section">
          <div class="section-header">
            <h2 class="section-title">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
                <path d="M0 1.5A1.5 1.5 0 0 1 1.5 0h13A1.5 1.5 0 0 1 16 1.5v13a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 14.5zM1.5 1a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-13a.5.5 0 0 0-.5-.5z"/>
                <path d="M2 2h12v2H2z"/>
              </svg>
              Derniers feedbacks
            </h2>
            <span class="feedbacks-count">{{ feedbackData.feedbacks.length }} feedbacks</span>
          </div>
          <div class="table-wrapper">
            <table class="feedbacks-table">
              <thead>
                <tr>
                  <th class="th-date">Date</th>
                  <th class="th-email">Email utilisateur</th>
                  <th class="th-mode">Mode</th>
                  <th class="th-rating">Rating</th>
                  <th class="th-comment">Commentaire</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(fb, idx) in feedbackData.feedbacks"
                  :key="fb.id"
                  :class="idx % 2 === 0 ? 'row-even' : 'row-odd'"
                >
                  <td class="td-date">{{ formatDateTime(fb.created_at) }}</td>
                  <td class="td-email">{{ fb.user_email }}</td>
                  <td class="td-mode">
                    <span class="mode-badge" :style="{ background: modeColor(fb.dossier_mode) }">
                      {{ fb.dossier_mode || 'standard' }}
                    </span>
                  </td>
                  <td class="td-rating">
                    <svg
                      v-if="fb.rating === 'positive'"
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="#4caf50"
                      viewBox="0 0 20 20"
                      class="rating-icon"
                    >
                      <path d="M9.56 2a2.5 2.5 0 0 1 2.452 2.99L11.609 7h2.235a2.75 2.75 0 0 1 2.713 3.202l-.681 4.082A3.25 3.25 0 0 1 12.67 17H4.5A1.5 1.5 0 0 1 3 15.5V9.238a1.5 1.5 0 0 1 1.059-1.433l1.14-.35.139-.048a2.75 2.75 0 0 0 1.56-1.453L8.41 2.59l.07-.13A1 1 0 0 1 9.322 2zM7.81 6.365a3.75 3.75 0 0 1-2.126 1.98l-.192.065-1.14.35A.5.5 0 0 0 4 9.239V15.5a.5.5 0 0 0 .5.5h8.17a2.25 2.25 0 0 0 2.22-1.88l.68-4.082A1.75 1.75 0 0 0 13.844 8H11a.5.5 0 0 1-.49-.598l.521-2.608A1.5 1.5 0 0 0 9.561 3h-.238z"/>
                    </svg>
                    <svg
                      v-else
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="#f44336"
                      viewBox="0 0 20 20"
                      class="rating-icon"
                    >
                      <path d="M12.67 3a3.25 3.25 0 0 1 3.206 2.716l.68 4.082A2.75 2.75 0 0 1 13.845 13H11.61l.403 2.01A2.5 2.5 0 0 1 9.56 18h-.238a1 1 0 0 1-.843-.46l-.069-.13-1.514-3.364a2.75 2.75 0 0 0-1.56-1.453l-.139-.047-1.14-.35A1.5 1.5 0 0 1 3 10.761V4.5A1.5 1.5 0 0 1 4.5 3zM4.5 4a.5.5 0 0 0-.5.5v6.262a.5.5 0 0 0 .353.477l1.14.35.19.065a3.75 3.75 0 0 1 2.127 1.98L9.323 17h.238a1.5 1.5 0 0 0 1.47-1.794l-.521-2.608A.5.5 0 0 1 11 12h2.844a1.75 1.75 0 0 0 1.726-2.038l-.68-4.082A2.25 2.25 0 0 0 12.67 4z"/>
                    </svg>
                  </td>
                  <td class="td-comment">
                    <span v-if="fb.comment" class="comment-text" :title="fb.comment">
                      {{ truncate(fb.comment, 80) }}
                    </span>
                    <span v-else class="comment-empty">--</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { supabase } from "@/supabase/supabaseClient";

export default {
  name: 'FeedbackMonitoring',
  data() {
    return {
      loading: true,
      error: null,
      feedbackData: null,
      adminPassword: null,
    }
  },
  computed: {
    positivePercent() {
      if (!this.feedbackData?.stats?.total) return 0;
      return Math.round((this.feedbackData.stats.positive / this.feedbackData.stats.total) * 100);
    },
    negativePercent() {
      if (!this.feedbackData?.stats?.total) return 0;
      return Math.round((this.feedbackData.stats.negative / this.feedbackData.stats.total) * 100);
    },
    commentRate() {
      if (!this.feedbackData?.stats?.negative) return 0;
      return Math.round((this.feedbackData.stats.with_comment / this.feedbackData.stats.negative) * 100);
    },
  },
  methods: {
    promptForPassword() {
      if (!this.adminPassword) {
        const password = prompt('Mot de passe administrateur requis:');
        if (!password) {
          throw new Error('Mot de passe requis pour accéder aux données administrateur');
        }
        this.adminPassword = password;
      }
      return this.adminPassword;
    },

    async fetchFeedbackData() {
      this.loading = true;
      this.error = null;

      try {
        const { data } = await supabase.auth.getSession();
        const jwt = data?.session?.access_token;
        if (!jwt) throw new Error('Session expirée');

        const adminPassword = this.promptForPassword();

        const response = await fetch('https://api.query-juriste.com/copilot/admin/get-feedback-monitoring', {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${jwt}`,
            'Content-Type': 'application/json',
            'X-Admin-Password': adminPassword
          }
        });

        if (!response.ok) {
          if (response.status === 403) this.adminPassword = null;
          throw new Error('Erreur lors du chargement des feedbacks');
        }

        const result = await response.json();
        this.feedbackData = result;
      } catch (error) {
        console.error('Error fetching feedback data:', error);
        this.error = error.message || 'Erreur de chargement des feedbacks';
      } finally {
        this.loading = false;
      }
    },

    formatDateTime(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleString('fr-FR', {
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    },

    truncate(text, maxLength) {
      if (!text) return '';
      if (text.length <= maxLength) return text;
      return text.substring(0, maxLength) + '...';
    },

    modeColor(mode) {
      const colors = {
        'FLASH': '#ff9800',
        'AGENT': '#2196f3',
        'TABLEAU': '#9c27b0',
        'standard': '#757575',
      };
      return colors[mode] || '#757575';
    },

    modePositivePercent(data) {
      const total = data.positive + data.negative;
      if (total === 0) return 0;
      return Math.round((data.positive / total) * 100);
    },
  },

  async mounted() {
    this.fetchFeedbackData();
  }
}
</script>

<style scoped>
.feedback-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 2rem 1rem;
}

.feedback-container {
  max-width: 1200px;
  margin: 0 auto;
}

/* Header */
.feedback-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 2rem;
  color: white;
}

.header-content {
  flex: 1;
}

.page-title {
  display: flex;
  align-items: center;
  gap: 1rem;
  font-size: 1.8rem;
  font-weight: 700;
  margin: 0 0 0.5rem 0;
  text-shadow: 0 2px 4px rgba(0,0,0,0.3);
}

.page-subtitle {
  font-size: 1.1rem;
  opacity: 0.9;
  margin: 0;
  font-weight: 300;
}

.back-button {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 8px 16px;
  background: rgba(255, 255, 255, 0.15);
  color: white;
  text-decoration: none;
  border-radius: 8px;
  font-size: 0.9rem;
  transition: all 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.back-button:hover {
  background: rgba(255, 255, 255, 0.25);
}

/* Loading & Error States */
.loading-state-full {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  color: white;
}

.loading-state-full p {
  margin-top: 1rem;
  font-size: 1.1rem;
  opacity: 0.9;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top: 3px solid white;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.error-state {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 16px;
  padding: 2rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  text-align: center;
}

.error-state p {
  font-size: 1.1rem;
  margin-bottom: 1.5rem;
  color: #e53e3e;
}

.retry-button {
  padding: 10px 24px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
}

.retry-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

/* Stats Cards Row */
.stats-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.stat-card {
  border-radius: 16px;
  padding: 1.5rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  color: white;
  transition: transform 0.3s ease;
}

.stat-card:hover {
  transform: translateY(-2px);
}

.stat-card-blue {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.stat-card-green {
  background: linear-gradient(135deg, #4caf50 0%, #2e7d32 100%);
}

.stat-card-red {
  background: linear-gradient(135deg, #f44336 0%, #c62828 100%);
}

.stat-card-orange {
  background: linear-gradient(135deg, #ff9800 0%, #e65100 100%);
}

.stat-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.2);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.stat-info {
  flex: 1;
  min-width: 0;
}

.stat-value {
  font-size: 1.8rem;
  font-weight: 700;
  color: white;
  line-height: 1.2;
}

.stat-percentage {
  font-size: 0.9rem;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.75);
}

.stat-label {
  font-size: 0.85rem;
  color: rgba(255, 255, 255, 0.9);
  margin-top: 2px;
  font-weight: 500;
}

/* Mode Breakdown Section */
.mode-breakdown-section {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 16px;
  padding: 2rem;
  margin-bottom: 2rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.section-title {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1.25rem;
  font-weight: 600;
  color: #2d3748;
  margin: 0 0 1.5rem 0;
}

.mode-cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 1rem;
}

.mode-card {
  background: #f7fafc;
  border-radius: 12px;
  padding: 1.25rem;
  border: 1px solid #e2e8f0;
  transition: transform 0.2s ease;
}

.mode-card:hover {
  transform: translateY(-2px);
}

.mode-card-header {
  margin-bottom: 0.75rem;
}

.mode-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 20px;
  color: white;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.mode-stats {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 0.75rem;
}

.mode-stat {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 0.95rem;
  font-weight: 600;
}

.mode-stat.positive {
  color: #4caf50;
}

.mode-stat.negative {
  color: #f44336;
}

.mode-stat.total {
  margin-left: auto;
}

.mode-total {
  font-size: 0.8rem;
  color: #718096;
  font-weight: 500;
}

.mode-bar {
  height: 6px;
  background: #fee2e2;
  border-radius: 3px;
  overflow: hidden;
}

.mode-bar-positive {
  height: 100%;
  background: #4caf50;
  border-radius: 3px;
  transition: width 0.5s ease;
}

/* Feedbacks Table Section */
.feedbacks-section {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 16px;
  padding: 2rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}

.feedbacks-count {
  font-size: 0.9rem;
  color: #667eea;
  font-weight: 600;
  background: rgba(102, 126, 234, 0.08);
  padding: 4px 12px;
  border-radius: 20px;
}

.table-wrapper {
  overflow-x: auto;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
}

.feedbacks-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9rem;
}

.feedbacks-table thead {
  background: rgba(102, 126, 234, 0.08);
}

.feedbacks-table th {
  padding: 12px 16px;
  text-align: left;
  font-weight: 600;
  color: #667eea;
  border-bottom: 2px solid rgba(102, 126, 234, 0.15);
  white-space: nowrap;
}

.feedbacks-table td {
  padding: 12px 16px;
  color: #2d3748;
  border-bottom: 1px solid #edf2f7;
  vertical-align: middle;
}

.th-date { width: 140px; }
.th-email { width: 220px; }
.th-mode { width: 110px; }
.th-rating { width: 70px; text-align: center; }
.th-comment { min-width: 200px; }

.td-date {
  white-space: nowrap;
  color: #718096;
  font-size: 0.85rem;
}

.td-email {
  font-weight: 500;
  max-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.td-mode {
  white-space: nowrap;
}

.td-rating {
  text-align: center;
}

.rating-icon {
  display: inline-block;
  vertical-align: middle;
}

.td-comment {
  max-width: 300px;
}

.comment-text {
  color: #4a5568;
  font-size: 0.85rem;
  line-height: 1.4;
  cursor: default;
}

.comment-empty {
  color: #cbd5e0;
}

.row-even {
  background: white;
}

.row-odd {
  background: #f7fafc;
}

.row-even:hover,
.row-odd:hover {
  background: rgba(102, 126, 234, 0.05);
}

/* Responsive */
@media (max-width: 1024px) {
  .stats-row {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .feedback-header {
    flex-direction: column;
    gap: 1rem;
  }

  .page-title {
    font-size: 1.4rem;
  }

  .stats-row {
    grid-template-columns: 1fr;
  }

  .mode-cards {
    grid-template-columns: 1fr;
  }

  .stat-value {
    font-size: 1.4rem;
  }
}
</style>
